'use client'

import { Popover, PopoverContent, PopoverTrigger } from "../shadcn/popover"
import { Button } from "../shadcn/button"
import { Check, ChevronDownIcon } from "lucide-react"
import { useState } from "react"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../shadcn/command"
import { cn } from "@/lib/utils"

export type ListFilterProps = {
    items: { value: string, label: string }[]
    placeholder: string
    search: boolean
    action: (value: string) => void
}

export default function ListFilter({ items, placeholder, search, action }: ListFilterProps) {
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState("")

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant={value == "" ? "outline" : "defaultLight"}
                    role="combobox"
                    size="lg"
                    aria-expanded={open}
                    className="justify-between"
                >
                    {value
                        ? items.find((item: any) => item.value === value)?.label
                        : placeholder}
                    <ChevronDownIcon className="opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[200px] p-0">
                <Command>
                    {search && (
                        <CommandInput placeholder="Rechercher" className="h-9" />
                    )}
                    <CommandList>
                        <CommandEmpty>Aucun résultat trouvé.</CommandEmpty>
                        <CommandGroup>
                            {items.map((item: any) => (
                                <CommandItem
                                    key={item.value}
                                    value={item.value}
                                    onSelect={(currentValue) => {
                                        setValue(currentValue === value ? "" : currentValue)
                                        setOpen(false)
                                        action(currentValue === value ? "" : currentValue)
                                    }}
                                >
                                    {item.label}
                                    <Check
                                        className={cn(
                                            "ml-auto",
                                            value === item.value ? "opacity-100" : "opacity-0"
                                        )}
                                    />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    )
}